<template>
    <b-container fluid>
    <b-row align-h="center">
      <b-col cols="12" lg="8">

        <b-row>
          <b-col>
            <!-- <b-button size="sm" class="mb-2" @click.prevent="goBack()">
              <b-icon icon="arrow-left-short" scale="2"></b-icon> Return to list
            </b-button>-->
            <b-link to="/plyr">
              <b-icon icon="arrow-left-short" scale="2"></b-icon> Plyr
            </b-link>
          </b-col>
        </b-row>
        <div class="page-header">
          <h2>{{ msg }}</h2>
        </div>

        <b-alert :show="loading" variant="info" class="mt-2">Loading....</b-alert>
        <b-alert v-if="error" show variant="danger" class="mt-2">No class selected.</b-alert>

        <b-row v-if="!error & !loading">
          <b-col cols="12">
            <div class="class-title">{{podcastShow.title}}</div>
            <div class="class-details">
              Sponsor: {{podcastShow.sponsorCompanyName}}
            </div>
          </b-col>
        </b-row>

        <b-row v-if="!error & !loading">
          <b-col cols="4">
              <b-img fluid v-bind:src="podcastShow.photo" />
          </b-col>
          <b-col cols="8" class="mt-2" :inner-html.prop="this.podcastShow.blurb | nl2br"></b-col>
        </b-row>

        <b-row v-if="!error">
          <b-col class="mt-3 mb-3">
            {{blurb}}
          </b-col>
        </b-row>

        <!-- episodes -->
        <b-row v-for="(row,ix) in podcasts" v-bind:key="row.id" class="mt-4 pt-2 pointer" style="border-top: 1px solid #CCC;">
          <b-col cols="2">
            <!-- {{row.id}} -->
            <div @click="play(ix)">
              <b-icon icon="play-fill" font-scale="2.5"></b-icon>
            </div>
          </b-col>
          <b-col cols="10" style="margin-left: -10px;" @click="activateRow(ix)">
            <div class="class-title">{{row.title}}</div>
            <div class="class-details">
              {{row.speakerName}}
              <br>{{row.releaseDateUTC | prettyDate}}<span v-if="row.credits > 0"> - {{row.credits}} CEU (Self Study)</span>
              <br>{{row.durationSec}}
            </div>
            <div class="class-details mt-2">
                {{row.blurb}}
            </div>
          </b-col>
        </b-row>

      </b-col>
    </b-row>

    </b-container>
</template>

<script>
/* eslint-disable */
'use strict'

import service from "@/service/service"
import utils from "@/utils/utils"

var data = {
  debug: false,
  error: false,
  loading: true,
  msg: "Plyr 2 Test",
  blurb: "Podcast series blurb.",
  obj: {},
  studentData: {status: false},
  studentHash: "",
  podcastHash: "",
  podcastShowHash: "",
  podcastShow: {status: false},
  podcasts: [],
  bannerAds: []
}

export default {
  name: 'Plyr2',
  data () {
    return data
  },
  props: {
    // route set to use props mapped to url parameters
    p: {
      type: String,
      default: ""
    },
    ps: {
      type: String,
      default: ""
    }
  },
  computed: {
    description: function() {
      return utils.nl2br(this.obj.description);
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    activateRow(ix) {
        console.log(`activateRow(${ix})`)
    },
    play(ix) {
        console.log(`changing to: ${this.podcasts[ix].mp3}`)
        let data = {
          title: this.podcasts[ix].title,
          mp3: this.podcasts[ix].mp3
        }
        this.$parent.playPlayer(data)
    },
    testme() {
      this.$parent.testme()
      // window.alert('testme')
    }
  },
  created() {
    // default to crosstex hash
    this.podcastShowHash = this.ps || this.$route.query.ps || '6D5840BF-6401-468E-87FE-E19359B92D8C'
    console.log(`ps: ${this.podcastShowHash}`)
    this.podcastHash = this.p || this.$route.query.p || ''
    this.studentHash = this.$root.getToken() || '';
    if (this.podcastShowHash) {
      service
        .getPodcastShow(this.podcastShowHash, this.studentHash)
        .then(
          (res => {
            console.log(`back from getPodcastShow!`);
            if (this.debug) console.log(res);
            if (res.status) {
              this.podcastShow = res.data[0]
              this.podcasts = res.podcasts.data
              this.bannerAds = res.bannerAds.bannerAds
              this.blurb = `All episodes from this series (${this.podcasts.length})`
            }
            else {
              this.error = true
            }
          }).bind(this)
        )
        .finally(e => {
          this.loading = false;
          console.log(`finally...`);
        })
        .catch(e => {
          this.error = true;
          console.log(e);
        });
    }
    else {
        // flag error!
    }
    // this.error = this.$root.getClassId() === 0;
  },
  mounted () {
    console.log('mounted')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Plyr2.vue